import React from 'react'
import Title from './../../../../components/typography/title.component'
import Container from '../../../../components/layout/container.component'
import AccordionSecondary from './../../../../components/accordion/accordion-secondary.component'
import PointsSolicitationSection from './components/points-solicitation-section.component'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../actions'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'

const containerStyle = { paddingBottom: '25px' }

class PointsSolicitationPageComponent extends React.Component {
	constructor(props) {
		super(props)

		this.getAccordionItems = getAccordionItems.bind(this)
	}

	render() {
		return (
			<Container style={containerStyle} medium>
				<Title>Solicitação de pontos</Title>
				<AccordionSecondary
					multiple
					noAnimated
					noClickable
					arrow={false}
					items={this.getAccordionItems()}
				/>
			</Container>
		)
	}
}

function getAccordionItems() {
	return [
		{
			title: 'Solicite os pontos das suas viagens',
			initiallyOpened: true,
			content: <PointsSolicitationSection />
		}
	]
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...SiteCreators,
			...toastActions
		},
		dispatch
	)

const connectedPointsSolicitationPageComponent = withRouter(
	connect(
		null,
		mapDispatchToProps
	)(PointsSolicitationPageComponent)
)

export { connectedPointsSolicitationPageComponent as ModuleRootComponent }
